module.exports = __webpack_public_path__ + "static/media/six3.a58df6e3.svg";